var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#4c248f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#4c248f;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.785,370.582c46.892-8.902,83.894-45.906,92.797-92.797h27.422v-43.574h-27.422 c-8.9-46.894-45.902-83.894-92.797-92.797v-27.422h-43.574v27.426c-46.89,8.898-83.894,45.902-92.795,92.793h-27.422v43.574h27.424 c8.9,46.89,45.902,83.894,92.793,92.793v27.426h43.574V370.582z M234.211,296.934v43.859c-30.822-7.93-55.078-32.184-63.008-63.008 h43.859v-43.574h-43.859c7.93-30.824,32.184-55.078,63.008-63.008v43.859h43.574v-43.859c30.824,7.93,55.08,32.184,63.01,63.008 h-43.859v43.574h43.857c-7.93,30.824-32.185,55.078-63.008,63.008v-43.859H234.211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.344,234.211C476.988,123.426,388.57,35.008,277.785,24.656V0h-43.574v24.656 C123.426,35.008,35.01,123.426,24.656,234.211H0v43.574h24.656C35.01,388.57,123.426,476.988,234.211,487.34V512h43.574v-24.66 c110.785-10.352,199.203-98.77,209.558-209.555H512v-43.574H487.344z M234.211,421.219v19.668 C148.924,430.898,81.1,363.074,71.109,277.785h19.67v-43.574h-19.67c9.99-85.289,77.815-153.113,163.102-163.102v19.668h43.574 V71.109c85.289,9.988,153.113,77.813,163.104,163.102h-19.67v43.574h19.67c-9.99,85.289-77.814,153.113-163.104,163.102v-19.668 H234.211z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSvgrepoCom);
export default __webpack_public_path__ + "static/media/target-svgrepo-com.356533e1cec8ea31af83031d8246196a.svg";
export { ForwardRef as ReactComponent };